import { render, staticRenderFns } from "./PackingListProfile.vue?vue&type=template&id=797feec8"
import script from "./PackingListProfile.vue?vue&type=script&lang=js"
export * from "./PackingListProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports